// import React, { useState, useEffect } from "react";
// import { NavLink, Outlet, useNavigate } from "react-router-dom";
// import logo from "../assets/AuraLogo.png";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faBars,
//   faSignOutAlt,
//   faHistory,
//   faPills,
//   faCalendarAlt,
//   faClock,
//   faUserMd,
//   faClinicMedical,
//   faTimes,
// } from "@fortawesome/free-solid-svg-icons";

// export default function Doctordashboard() {
//   const [isOpen, setIsOpen] = useState(false);
//   const [showMobileMenu, setShowMobileMenu] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);

//   const navigate = useNavigate();
//   const role = localStorage.getItem("Role");

//   useEffect(() => {
//     const handleResize = () => {
//       const mobile = window.innerWidth <= 900;
//       setIsMobile(mobile);
      
//       if (!mobile) {
//         setShowMobileMenu(false);
//         // Auto-expand sidebar on desktop when resizing from mobile
//         if (!isOpen) {
//           setIsOpen(true);
//         }
//       } else {
//         // Auto-collapse sidebar on mobile
//         setIsOpen(false);
//       }
//     };
    
//     window.addEventListener("resize", handleResize);
//     handleResize();
    
//     return () => window.removeEventListener("resize", handleResize);
//   }, [isOpen]);

//   const handleLogout = () => {
//     localStorage.removeItem("Token");
//     navigate("/admin");
//   };

//   const closeSidebar = () => {
//     setShowMobileMenu(false);
//     if (isMobile) {
//       setIsOpen(false);
//     }
//   };

//   const toggleSidebar = () => {
//     if (isMobile) {
//       setShowMobileMenu(!showMobileMenu);
//       setIsOpen(!showMobileMenu);
//     } else {
//       setIsOpen(!isOpen);
//     }
//   };

//   const handleOverlayClick = () => {
//     setShowMobileMenu(false);
//     setIsOpen(false);
//   };

//   // === Styles ===
//   const styles = {
//     wrapper: {
//       display: "flex",
//       height: "100vh",
//       width: "100%",
//       background: "#f5f7fa",
//       overflow: "hidden",
//       fontFamily: "'Roboto', sans-serif",
//     },
//     sidebar: {
//       width: isMobile ? "230px" : isOpen ? "250px" : "80px",
//       backgroundColor: "white",
//       color: "#007bff",
//       display: "flex",
//       flexDirection: "column",
//       justifyContent: "space-between",
//       transition: "all 0.3s ease",
//       position: isMobile ? "fixed" : "relative",
//       left: isMobile ? (showMobileMenu ? "0" : "-260px") : "0",
//       top: 0,
//       bottom: 0,
//       zIndex: 1000,
//       boxShadow: isMobile && showMobileMenu ? "2px 0 8px rgba(0,0,0,0.3)" : "none",
//       padding: "10px",
//     },
//     logo: {
//       display: "flex",
//       alignItems: "center",
//       justifyContent: isOpen ? "space-between" : "center",
//       padding: "10px",
//       borderBottom: "1px solid #e0e0e0",
//       textAlign: "center",
//       marginBottom: "20px",
//       backgroundColor: "white",
//       position: "relative",
//     },
//     logoImg: {
//       width: isOpen ? "123px" : "50px",
//       height: "auto",
//       transition: "0.3s",
//     },
//     closeIcon: {
//       display: isMobile ? "block" : "none",
//       fontSize: "1.5rem",
//       cursor: "pointer",
//       color: "blue",
//       position: "absolute",
//       top: "15px",
//       right: "15px",
//       zIndex: 1001,
//     },
//     menu: {
//       listStyle: "none",
//       padding: 0,
//       margin: 0,
//       flex: 1,
//       overflowY: "auto",
//     },
//     menuItem: {
//       padding: isOpen ? "12px 15px" : "12px 10px",
//       cursor: "pointer",
//       display: "flex",
//       alignItems: "center",
//       gap: "15px",
//       fontSize: "16px",
//       color: "#007bff",
//       textDecoration: "none",
//       transition: "all 0.3s ease",
//       borderRadius: "8px",
//       margin: "8px 0",
//       whiteSpace: "nowrap",
//       overflow: "hidden",
//       justifyContent: isOpen ? "flex-start" : "center",
//     },
//     activeTab: {
//       backgroundColor: "#007bff",
//       color: "white",
//     },
//     menuItemHover: {
//       backgroundColor: "#007bff",
//       color: "white",
//     },
//     logoutSection: {
//       listStyle: "none",
//       padding: "5px 0",
//       margin: 0,
//       position: "absolute",
//       bottom: "30px",
//       width: "calc(100% - 20px)",
//     },
//     logoutItem: {
//       padding: isOpen ? "12px 15px" : "12px 10px",
//       cursor: "pointer",
//       display: "flex",
//       alignItems: "center",
//       gap: "15px",
//       fontSize: "16px",
//       color: "#007bff",
//       transition: "all 0.3s ease",
//       borderRadius: "8px",
//       whiteSpace: "nowrap",
//       overflow: "hidden",
//       justifyContent: isOpen ? "flex-start" : "center",
//     },
//     mainContent: {
//       flex: 1,
//       marginLeft: isMobile ? "0" : isOpen ? "250px" : "80px",
//       transition: "margin-left 0.3s ease",
//       overflowY: "auto",
//       position: "relative",
//       height: "100vh",
//       backgroundColor: "#f5f7fa",
//       padding: "20px",
//       paddingTop: "70px",
//     },
//     menuIcon: {
//       fontSize: "1.5rem",
//       cursor: "pointer",
//       color: "blue",
//       display: "block",
//       position: "fixed",
//       top: "15px",
//       left: "15px",
//       zIndex: 900,
//       backgroundColor: "white",
//       padding: "10px",
//       borderRadius: "6px",
//       boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
//       width: "40px",
//       height: "40px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//     },
//     overlay: {
//       display: isMobile && showMobileMenu ? "block" : "none",
//       position: "fixed",
//       top: 0,
//       left: 0,
//       width: "100%",
//       height: "100%",
//       backgroundColor: "rgba(0, 0, 0, 0.5)",
//       zIndex: 999,
//     },
//     iconWrapper: {
//       width: "20px",
//       display: "flex",
//       justifyContent: "center",
//       flexShrink: 0,
//     },
//     menuText: {
//       opacity: isOpen ? 1 : 0,
//       width: isOpen ? "auto" : "0px",
//       transform: isOpen ? "translateX(0)" : "translateX(-10px)",
//       transition: "all 0.3s ease",
//       whiteSpace: "nowrap",
//       overflow: "hidden",
//       flexShrink: 0,
//     },
//     headerSpacer: {
//       height: "60px",
//       width: "100%",
//     }
//   };

//   return (
//     <div style={styles.wrapper}>
//       {/* Overlay for mobile when sidebar is open */}
//       <div style={styles.overlay} onClick={handleOverlayClick}></div>

//       {/* Menu Icon - Fixed position */}
//       <FontAwesomeIcon
//         icon={faBars}
//         style={styles.menuIcon}
//         onClick={toggleSidebar}
//       />

//       {/* Sidebar */}
//       <div style={styles.sidebar}>
//         <div style={styles.logo}>
//           <img src={logo} alt="Doctor Dashboard Logo" style={styles.logoImg} />
//           {isMobile && (
//             <FontAwesomeIcon icon={faTimes} style={styles.closeIcon} onClick={closeSidebar} />
//           )}
//         </div>

//         <ul style={styles.menu}>
//           {["Doc", "Admin", "Phuser"].includes(role) && (
//             <li>
//               <NavLink
//                 to="/dashboard/medical-history"
//                 style={({ isActive }) => ({
//                   ...styles.menuItem,
//                   ...(isActive ? styles.activeTab : {}),
//                 })}
//                 onMouseEnter={(e) => {
//                   e.target.style.backgroundColor = styles.menuItemHover.backgroundColor;
//                   e.target.style.color = styles.menuItemHover.color;
//                 }}
//                 onMouseLeave={(e) => {
//                   const isActive = e.target.classList.contains('active-tab') || 
//                                  e.target.parentElement.classList.contains('active-tab');
//                   if (!isActive) {
//                     e.target.style.backgroundColor = '';
//                     e.target.style.color = styles.menuItem.color;
//                   }
//                 }}
//                 onClick={closeSidebar}
//               >
//                 <div style={styles.iconWrapper}>
//                   <FontAwesomeIcon icon={faHistory} />
//                 </div>
//                 <span style={styles.menuText}>Patient Details</span>
//               </NavLink>
//             </li>
//           )}

//           <li>
//             <NavLink
//               to="register-medicines"
//               style={({ isActive }) => ({
//                 ...styles.menuItem,
//                 ...(isActive ? styles.activeTab : {}),
//               })}
//               onMouseEnter={(e) => {
//                 e.target.style.backgroundColor = styles.menuItemHover.backgroundColor;
//                 e.target.style.color = styles.menuItemHover.color;
//               }}
//               onMouseLeave={(e) => {
//                 const isActive = e.target.classList.contains('active-tab') || 
//                                e.target.parentElement.classList.contains('active-tab');
//                 if (!isActive) {
//                   e.target.style.backgroundColor = '';
//                   e.target.style.color = styles.menuItem.color;
//                 }
//               }}
//               onClick={closeSidebar}
//             >
//               <div style={styles.iconWrapper}>
//                 <FontAwesomeIcon icon={faPills} />
//               </div>
//               <span style={styles.menuText}>Drug / Services</span>
//             </NavLink>
//           </li>

//           <li>
//             <NavLink
//               to="pharmacy"
//               style={({ isActive }) => ({
//                 ...styles.menuItem,
//                 ...(isActive ? styles.activeTab : {}),
//               })}
//               onMouseEnter={(e) => {
//                 e.target.style.backgroundColor = styles.menuItemHover.backgroundColor;
//                 e.target.style.color = styles.menuItemHover.color;
//               }}
//               onMouseLeave={(e) => {
//                 const isActive = e.target.classList.contains('active-tab') || 
//                                e.target.parentElement.classList.contains('active-tab');
//                 if (!isActive) {
//                   e.target.style.backgroundColor = '';
//                   e.target.style.color = styles.menuItem.color;
//                 }
//               }}
//               onClick={closeSidebar}
//             >
//               <div style={styles.iconWrapper}>
//                 <FontAwesomeIcon icon={faClinicMedical} />
//               </div>
//               <span style={styles.menuText}>Invoice Management</span>
//             </NavLink>
//           </li>

//           <li>
//             <NavLink
//               to="doctor-profile"
//               style={({ isActive }) => ({
//                 ...styles.menuItem,
//                 ...(isActive ? styles.activeTab : {}),
//               })}
//               onMouseEnter={(e) => {
//                 e.target.style.backgroundColor = styles.menuItemHover.backgroundColor;
//                 e.target.style.color = styles.menuItemHover.color;
//               }}
//               onMouseLeave={(e) => {
//                 const isActive = e.target.classList.contains('active-tab') || 
//                                e.target.parentElement.classList.contains('active-tab');
//                 if (!isActive) {
//                   e.target.style.backgroundColor = '';
//                   e.target.style.color = styles.menuItem.color;
//                 }
//               }}
//               onClick={closeSidebar}
//             >
//               <div style={styles.iconWrapper}>
//                 <FontAwesomeIcon icon={faUserMd} />
//               </div>
//               <span style={styles.menuText}>User Profile</span>
//             </NavLink>
//           </li>

//           {(role === "Doc" || role === "Admin") && (
//             <li>
//               <NavLink
//                 to="daily-appointments"
//                 style={({ isActive }) => ({
//                   ...styles.menuItem,
//                   ...(isActive ? styles.activeTab : {}),
//                 })}
//                 onMouseEnter={(e) => {
//                   e.target.style.backgroundColor = styles.menuItemHover.backgroundColor;
//                   e.target.style.color = styles.menuItemHover.color;
//                 }}
//                 onMouseLeave={(e) => {
//                   const isActive = e.target.classList.contains('active-tab') || 
//                                  e.target.parentElement.classList.contains('active-tab');
//                   if (!isActive) {
//                     e.target.style.backgroundColor = '';
//                     e.target.style.color = styles.menuItem.color;
//                   }
//                 }}
//                 onClick={closeSidebar}
//               >
//                 <div style={styles.iconWrapper}>
//                   <FontAwesomeIcon icon={faCalendarAlt} />
//                 </div>
//                 <span style={styles.menuText}>Appointments</span>
//               </NavLink>
//             </li>
//           )}

//           {role === "Admin" && (
//             <>
//               <li>
//                 <NavLink
//                   to="add-timeslot"
//                   style={({ isActive }) => ({
//                     ...styles.menuItem,
//                     ...(isActive ? styles.activeTab : {}),
//                   })}
//                   onMouseEnter={(e) => {
//                     e.target.style.backgroundColor = styles.menuItemHover.backgroundColor;
//                     e.target.style.color = styles.menuItemHover.color;
//                   }}
//                   onMouseLeave={(e) => {
//                     const isActive = e.target.classList.contains('active-tab') || 
//                                    e.target.parentElement.classList.contains('active-tab');
//                     if (!isActive) {
//                       e.target.style.backgroundColor = '';
//                       e.target.style.color = styles.menuItem.color;
//                     }
//                   }}
//                   onClick={closeSidebar}
//                 >
//                   <div style={styles.iconWrapper}>
//                     <FontAwesomeIcon icon={faClock} />
//                   </div>
//                   <span style={styles.menuText}>Add Timeslots</span>
//                 </NavLink>
//               </li>

//               <li>
//                 <NavLink
//                   to="add-users"
//                   style={({ isActive }) => ({
//                     ...styles.menuItem,
//                     ...(isActive ? styles.activeTab : {}),
//                   })}
//                   onMouseEnter={(e) => {
//                     e.target.style.backgroundColor = styles.menuItemHover.backgroundColor;
//                     e.target.style.color = styles.menuItemHover.color;
//                   }}
//                   onMouseLeave={(e) => {
//                     const isActive = e.target.classList.contains('active-tab') || 
//                                    e.target.parentElement.classList.contains('active-tab');
//                     if (!isActive) {
//                       e.target.style.backgroundColor = '';
//                       e.target.style.color = styles.menuItem.color;
//                     }
//                   }}
//                   onClick={closeSidebar}
//                 >
//                   <div style={styles.iconWrapper}>
//                     <FontAwesomeIcon icon={faUserMd} />
//                   </div>
//                   <span style={styles.menuText}>Add Users</span>
//                 </NavLink>
//               </li>
//             </>
//           )}
//         </ul>

//         <ul style={styles.logoutSection}>
//           <li 
//             onClick={handleLogout} 
//             style={styles.logoutItem}
//             onMouseEnter={(e) => {
//               e.target.style.backgroundColor = styles.menuItemHover.backgroundColor;
//               e.target.style.color = styles.menuItemHover.color;
//             }}
//             onMouseLeave={(e) => {
//               e.target.style.backgroundColor = '';
//               e.target.style.color = styles.menuItem.color;
//             }}
//           >
//             <div style={styles.iconWrapper}>
//               <FontAwesomeIcon icon={faSignOutAlt} />
//             </div>
//             <span style={styles.menuText}>Logout</span>
//           </li>
//         </ul>
//       </div>

//       {/* Main content */}
//       <div style={styles.mainContent}>
//         <div style={styles.headerSpacer}></div>
//         <Outlet />
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  Drawer,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  Menu as MenuIcon,
  Logout as LogoutIcon,
  History as HistoryIcon,
  Medication as MedicationIcon,
  MedicalServices as MedicalServicesIcon,
  Person as PersonIcon,
  CalendarMonth as CalendarIcon,
  AccessTime as TimeIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import logo from "../assets/AuraLogo.png";

export default function Doctordashboard() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [sidebarOpen, setSidebarOpen] = useState(false); // Start closed to prevent layout shift
  const navigate = useNavigate();
  const role = localStorage.getItem("Role");

  useEffect(() => {
    // Set initial state based on screen size
    const setInitialSidebarState = () => {
      if (isMobile) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };

    // Use timeout to prevent layout shift on initial load
    const timer = setTimeout(setInitialSidebarState, 100);
    
    return () => clearTimeout(timer);
  }, [isMobile]);

  // Ensure proper layout on page load and resize
  useEffect(() => {
    const handleResize = () => {
      // Force a reflow to ensure proper positioning
      if (window.innerWidth >= 960) {
        setSidebarOpen(true);
      } else {
        setSidebarOpen(false);
      }
    };

    // Initial check with delay to prevent flash
    const timer = setTimeout(handleResize, 200);
    
    window.addEventListener('resize', handleResize);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("Token");
    navigate("/admin");
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    if (isMobile) {
      setSidebarOpen(false);
    }
  };

  const drawerWidth = 250;
  const collapsedWidth = 80;

  const menuItems = [
    ...(["Doc", "Admin", "Phuser"].includes(role)
      ? [
          {
            text: "Patient Details",
            icon: <HistoryIcon />,
            to: "/dashboard/medical-history",
          },
        ]
      : []),
    {
      text: "Drug / Services",
      icon: <MedicationIcon />,
      to: "register-medicines",
    },
    {
      text: "Invoice Management",
      icon: <MedicalServicesIcon />,
      to: "pharmacy",
    },
    {
      text: "User Profile",
      icon: <PersonIcon />,
      to: "doctor-profile",
    },
    ...((role === "Doc" || role === "Admin")
      ? [
          {
            text: "Appointments",
            icon: <CalendarIcon />,
            to: "daily-appointments",
          },
        ]
      : []),
    ...(role === "Admin"
      ? [
          {
            text: "Add Timeslots",
            icon: <TimeIcon />,
            to: "add-timeslot",
          },
          {
            text: "Add Users",
            icon: <PersonIcon />,
            to: "add-users",
          },
        ]
      : []),
  ];

  const drawer = (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      {/* Logo */}
      <Box
        sx={{
          p: 2,
          borderBottom: 1,
          borderColor: "divider",
          display: "flex",
          alignItems: "center",
          justifyContent: sidebarOpen ? "space-between" : "center",
          minHeight: 64,
        }}
      >
        <img
          src={logo}
          alt="Aura Logo"
          style={{
            width: sidebarOpen ? "123px" : "40px",
            height: "auto",
            transition: "width 0.3s ease",
          }}
        />
        {isMobile && (
          <IconButton onClick={closeSidebar} size="small" sx={{ color: "primary.main" }}>
            <CloseIcon />
          </IconButton>
        )}
      </Box>

      {/* Menu Items */}
      <List sx={{ flex: 1, px: 1, py: 0 }}>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding sx={{ mb: 0.5 }}>
            <ListItemButton
              component={NavLink}
              to={item.to}
              onClick={closeSidebar}
              sx={{
                borderRadius: 1,
                justifyContent: sidebarOpen ? "initial" : "center",
                px: sidebarOpen ? 2 : 1,
                py: 1.5,
                minHeight: '48px',
                color: "primary.main",
                "&.active": {
                  backgroundColor: "primary.main",
                  color: "white",
                  "& .MuiListItemIcon-root": {
                    color: "white",
                  },
                },
                "&:hover": {
                  backgroundColor: "primary.main",
                  color: "white",
                  "& .MuiListItemIcon-root": {
                    color: "white",
                  },
                },
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: sidebarOpen ? 2 : "auto",
                  justifyContent: "center",
                  color: "primary.main",
                }}
              >
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.text}
                sx={{
                  opacity: sidebarOpen ? 1 : 0,
                  transition: "opacity 0.2s ease",
                  "& .MuiTypography-root": {
                    fontSize: "0.875rem",
                    fontWeight: 500,
                    color: "inherit",
                  },
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      {/* Logout Button */}
      <Box sx={{ p: 1 }}>
        <ListItem disablePadding>
          <ListItemButton
            onClick={handleLogout}
            sx={{
              borderRadius: 1,
              justifyContent: sidebarOpen ? "initial" : "center",
              px: sidebarOpen ? 2 : 1,
              py: 1.5,
              minHeight: '48px',
              color: "primary.main",
              "&:hover": {
                backgroundColor: "error.main",
                color: "white",
                "& .MuiListItemIcon-root": {
                  color: "white",
                },
              },
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: sidebarOpen ? 2 : "auto",
                justifyContent: "center",
                color: "primary.main",
              }}
            >
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText
              primary="Logout"
              sx={{
                opacity: sidebarOpen ? 1 : 0,
                transition: "opacity 0.2s ease",
                "& .MuiTypography-root": {
                  fontSize: "0.875rem",
                  fontWeight: 500,
                  color: "inherit",
                },
              }}
            />
          </ListItemButton>
        </ListItem>
      </Box>
    </Box>
  );

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      {/* App Bar */}
      <AppBar
        position="fixed"
        sx={{
          width: isMobile
            ? "100%"
            : `calc(100% - ${sidebarOpen ? drawerWidth : collapsedWidth}px)`,
          left: isMobile ? 0 : `${sidebarOpen ? drawerWidth : collapsedWidth}px`,
          right: 0,
          transition: theme.transitions.create(["width", "left"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          backgroundColor: "white",
          color: "primary.main",
          boxShadow: 1,
          zIndex: theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar variant="dense" sx={{ minHeight: 48 }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={toggleSidebar}
            edge="start"
            sx={{ 
              mr: 2,
              color: "primary.main"
            }}
          >
            <MenuIcon />
          </IconButton>
          
        </Toolbar>
      </AppBar>

      {/* Sidebar Drawer */}
      <Drawer
        variant={isMobile ? "temporary" : "permanent"}
        open={sidebarOpen}
        onClose={closeSidebar}
        sx={{
          width: sidebarOpen ? drawerWidth : collapsedWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: sidebarOpen ? drawerWidth : collapsedWidth,
            boxSizing: "border-box",
            transition: theme.transitions.create("width", {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
            overflowX: "hidden",
            top: 48,
            height: 'calc(100% - 48px)',
            borderRight: 'none',
            boxShadow: 2,
            position: "fixed",
            zIndex: theme.zIndex.drawer,
          },
        }}
      >
        {drawer}
      </Drawer>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          position: "absolute",
          top: 48,
          left: isMobile ? 0 : `${sidebarOpen ? drawerWidth : collapsedWidth}px`,
          right: 0,
          bottom: 0,
          width: isMobile
            ? "100%"
            : `calc(100% - ${sidebarOpen ? drawerWidth : collapsedWidth}px)`,
          transition: theme.transitions.create(["width", "left"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          backgroundColor: theme.palette.background.default,
          overflowY: "auto",
          overflowX: "hidden",
          padding: 0,
          margin: 0,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}